const EmptyScreen = () => {
  return <div className="w-full h-screen"></div>;
};

export default EmptyScreen;
